var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-checkbox', {
    attrs: {
      "id": _vm.id,
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.formValue,
      callback: function ($$v) {
        _vm.formValue = $$v;
      },
      expression: "formValue"
    }
  }, [_vm._t("icon"), _c('div', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }